import { render, staticRenderFns } from "./boxGg.vue?vue&type=template&id=514328ac&scoped=true&"
import script from "./boxGg.vue?vue&type=script&lang=js&"
export * from "./boxGg.vue?vue&type=script&lang=js&"
import style0 from "./boxGg.vue?vue&type=style&index=0&id=514328ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514328ac",
  null
  
)

export default component.exports